var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFDD2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11H30.5V21.5636C30.5 24.2701 29.0551 26.7743 26.7118 28.1257L20 32L13.2882 28.1257C10.9449 26.7706 9.5 24.2701 9.5 21.5636V11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2656 16.5586V19.8452C15.7148 19.3361 16.5309 18.9955 17.4667 18.9955H18.4811V22.8137C18.4811 23.8281 18.2041 24.719 17.7961 25.2094H22.2095C21.8015 24.719 21.5244 23.8319 21.5244 22.8174V18.9955H22.5389C23.471 18.9955 24.2908 19.3399 24.74 19.8452V16.5586H15.2656Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbIcon);
export default __webpack_public_path__ + "static/media/tbIcon.9d60106484a0ee0271416f406412fea1.svg";
export { ForwardRef as ReactComponent };